import MachinaryIcon from "assets/img/machin.png";
import IrrigationNetwork from "assets/img/irrigationNetwork.png";
import ElectricityNetwork from "assets/img/ElecNetwork.png";
import ElectricitySource from "assets/svg/ElectricitySource.svg";
import ElectricityMeters from "assets/svg/ElectricityMeters.svg";
import Cameras from "assets/img/cameras.png";
import FertigatorsIcon from "assets/img/fertigators.png";
import HorschTiger from "assets/svg/HorschTiger.svg";
import HarvesterIcon from "assets/svg/HarvesterIcon.svg";
import DiggerIcon from "assets/svg/DiggerIcon.svg";
import OpenerIcon from "assets/svg/OpenerIcon.svg";
import SprayerIcon from "assets/svg/SprayerIcon.svg";
import SpreaderIcon from "assets/svg/SpreaderIcon.svg";
import PlanterIcon from "assets/svg/PlanterIcon.svg";
import RotavatorIcon from "assets/svg/RotavatorIcon.svg";
import MarkerIcon from "assets/svg/MarkerIcon.svg";
import DiskIcon from "assets/svg/DiskIcon.svg";
import PlowerIcon from "assets/svg/PlowerIcon.svg";
import TractorIcon from "assets/svg/TractorIcon.svg";
import CenterPivotFarming from "assets/svg/CenterPivotFarming.svg";
import TreeFarming from "assets/svg/TreeFarming.svg";
import WaterSources from "assets/svg/WaterSourceWhite.svg";
import PumpsIcon from "assets/svg/pumpsIconWhite.svg";
import FlowMetersIcon from "assets/svg/FlowMetterWhite.svg";
import PipesIcon from "assets/svg/pipesIconWhite.svg";
import ValvesIcon from "assets/svg/VAlvesIconWhite.svg";
import DripsIcon from "assets/svg/DripsIcon.svg";
import PivotsIcon from "assets/svg/PivotsIcon.svg";
import Drip from "assets/svg/Drip.svg";
import { useTranslation } from "react-i18next";

export const Categories = (t: any) => [
  {
    label: t("machinery"),
    path: "assets/machinary",
    color: "#F1C95E",
    icon: MachinaryIcon,
    p: t("List of Machinery items"),
    subData: [
      {
        label: t("tractor"),
        path: "machinary/tractor",
        icon: TractorIcon,
        color: "#F1C95E",
        p: t("List of Tractors Machines"),
      },
      {
        label: t("plower"),
        path: "machinary/plower",
        icon: PlowerIcon,
        color: "#F15E5E",
        p: t("List of Plower Machines"),
      },
      {
        label: t("disk"),
        path: "machinary/disk",
        icon: DiskIcon,
        color: "#0D9CFF",
        p: t("List of Disk Machines"),
      },
      {
        label: t("marker"),
        path: "machinary/marker",
        icon: MarkerIcon,
        color: "#547445",
        p: t("List of Marker Machines"),
      },
      {
        label: t("rotavator"),
        path: "machinary/rotavator",
        icon: RotavatorIcon,
        color: "#FE61F8",
        p: t("List of Rotavator Machines"),
      },

      {
        label: t("planter"),
        path: "machinary/planter",
        icon: PlanterIcon,
        color: "#CB8252",
        p: t("List of Planter Machines"),
      },
      {
        label: t("spreader"),
        path: "machinary/spreader",
        icon: SpreaderIcon,
        color: "#FFA500",
        p: t("List of Spreader Machines"),
      },
      {
        label: t("sprayer"),
        path: "machinary/sprayer",
        icon: SprayerIcon,
        color: "#A384E2",
        p: t("List of Sprayer Machines"),
      },
      {
        label: t("opener"),
        path: "machinary/opener",
        icon: OpenerIcon,
        color: "#A4E869",
        p: t("List of Opener Machines"),
      },
      {
        label: t("digger"),
        path: "machinary/digger",
        icon: DiggerIcon,
        color: "#CA9E67",
        p: t("List of Digger Machines"),
      },
      {
        label: t("harvester"),
        path: "machinary/harvester",
        icon: HarvesterIcon,
        p: t("List of Harvester Machines"),
        color: "#FF507A",
      },
      {
        label: t("horsch Tiger"),
        path: "machinary/horsch-tiger",
        icon: HorschTiger,
        p: t("List of Horsch Tiger Machines"),
        color: "#547445",
      },
    ],
  },
  {
    label: t("irrigation-network"),
    path: "assets/irrigation-network",
    color: "#F15E5E",
    icon: IrrigationNetwork,
    p: t("List of Irrigation network items"),
    subData: [
      {
        label: t("Drip"),
        color: "#B3503A",
        path: "irrigation-network/tree-farming",
        p: t("Irrigation Network for Drip Irrigation System"),
        icon: Drip,
        subData: [
          {
            label: t("water-sources"),
            path: "/assets/irrigation-network/tree-farming/water-sources",
            icon: WaterSources,
            color: "#F1C95E",
            p: t("water-sources"),
          },
          {
            label: t("pumps"),
            path: "/assets/irrigation-network/tree-farming/pump",
            icon: PumpsIcon,
            color: "#F15E5E",
            p: t("pumps"),
          },
          {
            label: t("flow-meters"),
            path: "/assets/irrigation-network/tree-farming/flow-meters",
            icon: FlowMetersIcon,
            color: "#0D9CFF",
            p: t("flow-meters"),
          },
          {
            label: t("pipes"),
            path: "/assets/irrigation-network/tree-farming/pipes",
            icon: PipesIcon,
            color: "#547445",
            p: t("pipes"),
          },
          {
            label: t("valves"),
            path: "/assets/irrigation-network/tree-farming/valves",
            icon: ValvesIcon,
            color: "#FE61F8",
            p: t("valves"),
          },
        ],
      },
      {
        label: t("Center Pivot"),
        path: "irrigation-network/center-pivot-farming",
        icon: CenterPivotFarming,
        p: t("Irrigation Network for Center Pivot System"),
        color: "#4C8625",
        subData: [
          {
            label: t("water-sources"),
            path: "/assets/irrigation-network/center-pivot-farming/water-sources",
            icon: WaterSources,
            color: "#F1C95E",
            p: t("water-sources"),
          },
          {
            label: t("pumps"),
            path: "/assets/irrigation-network/center-pivot-farming/pumps",
            icon: PumpsIcon,
            color: "#F15E5E",
            p: t("pumps"),
          },
          {
            label: t("flow-meters"),
            path: "/assets/irrigation-network/center-pivot-farming/flow-meters",
            icon: FlowMetersIcon,
            color: "#0D9CFF",
            p: t("flow-meters"),
          },
          {
            label: t("pivots"),
            path: "/assets/irrigation-network/center-pivot-farming/pivots",
            icon: PivotsIcon,
            color: "#547445",
            p: t("pivots"),
          },
        ],
      },

      /*   {
        label: t("Flood"),
        color: "#0D9CFF",
        path: "#",
        p: "Irrigation Network for flood Farming",
        icon: TreeFarming,
        subData: [],
      }, */
    ],
  },
  {
    label: t("electricity-network"),
    color: "#0D9CFF",
    path: "assets/electricity-network",
    icon: ElectricityNetwork,
    p: t("Electricity network items"),
    subData: [
      {
        label: t("electricity-source"),
        path: "electricity-network/electricity-source",
        color: "#0D9CFF",
        p: t("Electricity Meters"),
        icon: ElectricitySource,
      },
      {
        label: t("electricity-meters"),
        color: "#FF9C00",
        p: t("Electricity Source ( Electricity or Generator )"),
        path: "electricity-network/electricity-meters",
        icon: ElectricityMeters,
      },
    ],
  },
  {
    label: t("cameras"),
    path: "assets/cameras",
    icon: Cameras,
    color: "#547445",
    p: t("Cameras"),
  },
  {
    label: t("fertigators"),
    path: "assets/fertigators",
    icon: FertigatorsIcon,
    color: "#FE61F8",
    p: t("Fertigators assets"),
  },
];
